import React from "react";
import { Box, Heading, Text } from "@chakra-ui/react";
import FormFields from "./Fields";
const FormBody = ({ formik, formConfig, formWidth, title }) => {
  const {
    title: formConfigTitle,
    description,
    dropped,
    submitConfig,
    standardFields,
  } = formConfig;
  return (
    <Box bg="background.secondary" m="0 auto" p="2rem" w={formWidth}>
      <form onSubmit={formik.handleSubmit}>
        <Heading mb="2" as="h5" size="md">
          {formConfigTitle == "Add a form title" ? title : formConfigTitle}
        </Heading>
        <Text mb="3">{description}</Text>
        <FormFields
          standardFields={standardFields}
          fields={dropped}
          formik={formik}
          submitConfig={submitConfig}
        />
      </form>
    </Box>
  );
};

export default FormBody;
